

import { useState } from 'react';
import { Stack, Text, Box, UnstyledButton } from '@mantine/core';
import { PAGE_ELEMENT_CATEGORIES } from '@/features/editor/pageElements';

interface Props {
  onAdd: (type: string) => void;
}

export default function PageElementPalette({ onAdd }: Props) {
  const [expandedCategories] = useState<Set<string>>(
    new Set(PAGE_ELEMENT_CATEGORIES.map((cat) => cat.id))
  );

  return (
    <Stack gap="lg">
      {PAGE_ELEMENT_CATEGORIES.map((category) => {
        const isExpanded = expandedCategories.has(category.id);
        if (!isExpanded) return null;

        return (
          <Box key={category.id}>
            <Text
              size="xs"
              fw={700}
              c="#415A91"
              mb={8}
              style={{ fontStyle: 'italic' }}
            >
              {category.label}
            </Text>

            <Stack gap={6}>
              {category.elements.map((element) => (
                <UnstyledButton
                  key={element.type}
                  onClick={() => onAdd(element.type)}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10,
                    padding: '8px 12px',
                    borderRadius: 8,
                    backgroundColor: '#FFFFFF',
                    border: '1px solid #E4E7ED',
                    transition: 'all 0.15s ease',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.backgroundColor = '#E8EDF5';
                    e.currentTarget.style.borderColor = '#7897C3';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundColor = '#FFFFFF';
                    e.currentTarget.style.borderColor = '#E4E7ED';
                  }}
                >
                  <Box style={{ color: '#6B7A8E', display: 'flex', alignItems: 'center' }}>
                    {element.icon}
                  </Box>
                  <Text size="sm" fw={500} c="#2A3140">
                    {element.label}
                  </Text>
                </UnstyledButton>
              ))}
            </Stack>
          </Box>
        );
      })}
    </Stack>
  );
}
